import dayjs from 'dayjs'
import i18n from '@/locales/index'

export default function(date) {
  if (!date) return i18n.tc('unknown')
  return dayjs(date).format('DD-MM-YYYY')
}
